<div class="container content" [formGroup]="formGroup">
    <!-- <h5 class="title-step" align="center">
        <img src="./assets/img/users.svg" class="img-fluid ico-title" width="20"> Datos cliente
    </h5> -->

    <h5 class="title-step" align="center">
        <img src="./assets/img/users.svg" class="img-fluid ico-title" width="20"> Datos personales
    </h5>
    <div class="card">
        <ul class="list-group list-group-flush">
            <li class="list-group-item cuerpo-pack">
                <div class="form-row">
                    <div class="col-lg-2 mt-1">
                        <mat-form-field>
                            <mat-label>Tipo documento</mat-label>
                            <select matNativeControl required formControlName="doctype"
                                    (change)="changeTypeDocument($event.target.value); setMaxLengthByDoc($event.target.value)">
                                <option *ngFor="let documentType of documentTypes" [value]="documentType.document_type_id">{{ documentType.description }}</option>
                            </select>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-2 mt-1">
                        <mat-form-field>
                            <mat-label>Nº de documento</mat-label>
                            <input matInput type="text" name="doc" formControlName="doc" [maxLength]="maxLengthByDoc" required>                            
                            <!-- error -->
                            <mat-error *ngIf="formGroup.get('doc')?.errors?.required">
                                Campo obligatorio.
                            </mat-error>
                            <mat-error *ngIf="formGroup.get('doc')?.errors?.doc && !formGroup.get('doc')?.errors?.required">
                                Número de documento erróneo
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-2 mt-1">
                        <mat-form-field>
                            <mat-label>Nacionalidad</mat-label>
                            <select matNativeControl required formControlName="country">
                                <ng-container *ngFor="let country of countries;">
                                    <option *ngIf="!((formGroup.get('doctype').value === '2' || formGroup.get('doctype').value === 2) && country.code === 'ES')" [value]="country.code">
                                        {{ country.description }}
                                    </option>
                                </ng-container>
                            </select>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-2 mt-1">
                        <mat-form-field>
                            <mat-label>Nombre</mat-label>
                            <input matInput type="text" oninvalid="" required formControlName="firstName">
                        </mat-form-field>
                    </div>

                    <div class="col-lg-2 mt-1">
                        <mat-form-field>
                            <mat-label>Apellido1</mat-label>
                            <input matInput type="text" oninvalid="" required formControlName="surname1">
                        </mat-form-field>
                    </div>

                    <div class="col-lg-2 mt-1">
                        <mat-form-field>
                            <mat-label>Apellido2</mat-label>
                            <input matInput type="text" oninvalid="" formControlName="surname2">
                        </mat-form-field>
                    </div>

                    <div class="col-lg-2 mt-1">
                        <mat-form-field>
                            <mat-label>Fecha de nacimiento</mat-label>
                            <input matInput [matDatepicker]="picker" [max]="maxDate" [min]="minDate" required formControlName="birthday">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-2 mt-1">
                        <mat-form-field>
                            <mat-label>Sexo</mat-label>
                            <select matNativeControl formControlName="sex">
                                <option value="M">Masculino</option>
                                <option value="F">Femenino</option>
                            </select>
                        </mat-form-field>
                    </div>

                    <!-- Este campo aparece si se elige CIF -->

                    <div class="col-lg-4 mt-1" *ngIf="requireCif">
                        <mat-form-field>
                            <mat-label>Razón social</mat-label>
                            <input matInput type="text" oninvalid="" formControlName="company" maxlength="60">
                        </mat-form-field>
                    </div>
                </div>
            </li>
        </ul>
    </div>

    <h5 class="title-step mt-4" align="center">
        <img src="./assets/img/users.svg" class="img-fluid ico-title" width="20"> Datos de contacto
    </h5>
    <div class="card">
        <ul class="list-group list-group-flush">
            <li class="list-group-item cuerpo-pack">
                <div class="form-row">
                    <div class="col-lg-3 mb-1" *ngIf="requestSelectionRoadTypeManually">
                        <mat-form-field>
                            <mat-label>Tipo de vía</mat-label>
                            <select matNativeControl formControlName="tipoVia" required>
                                <option *ngFor='let datos of roadTypes' value="{{datos.code}}">{{datos.code}}</option>
                            </select>
                            <mat-error>
                                Campo obligatorio.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div [class.col-lg-7]="!requestSelectionRoadTypeManually" [class.col-lg-4]="requestSelectionRoadTypeManually" class="mb-1">
                        <mat-form-field>
                            <mat-label>Nombre de la vía</mat-label>
                            <input matInput matGoogleMapsAutocomplete required type="text" name="nombreVia" formControlName="nombreVia"
                                   [types]="['address']"
                                   [country]="country"
                                   (onAutocompleteSelected)="onAutocompleteSelected($event)">
                            <!-- error -->
                            <mat-error>
                                Campo obligatorio.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-2 mb-1">
                        <mat-form-field>
                            <mat-label>Número</mat-label>
                            <input matInput type="number" name="numero" formControlName="numero" required pattern="\d+" min="0">
                            <!-- error -->
                            <mat-error>
                                Campo obligatorio.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-1 mb-1">
                        <mat-form-field>
                            <mat-label>Planta</mat-label>
                            <input type="text" matInput formControlName="planta">
                        </mat-form-field>
                    </div>

                    <div class="col-lg-1 mb-1">
                        <mat-form-field>
                            <mat-label>Puerta</mat-label>
                            <input type="text" matInput formControlName="puerta">
                        </mat-form-field>
                    </div>

                    <div class="col-lg-1 mb-1">
                        <mat-form-field>
                            <mat-label>Escalera</mat-label>
                            <input type="text" matInput formControlName="escalera">
                        </mat-form-field>
                    </div>
                </div>

                <!--SEGUNDA FILA-->
                <div class="form-row">
                    <div class="col-lg-3 mb-1">
                        <mat-form-field>
                            <mat-label>Código Postal</mat-label>
                            <input matInput type="number" name="codigoPostal" formControlName="codigoPostal" required (input)="onChangeZip($event.target.value)" pattern="\d+" min="0">
                            <!-- error -->
                            <mat-error>
                                Campo obligatorio.
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-5 mb-1">
                        <mat-form-field>
                            <mat-label>Localidad</mat-label>
                            <input matInput type="text" name="localidad" formControlName="localidad" required
                                   (input)="searchCity($event.target.value)" [matAutocomplete]="auto">
                            <mat-autocomplete #auto="matAutocomplete" [panelWidth]="450">
                                <mat-option *ngFor="let option of cityFilteredOptions | async" [value]="option.normalized">
                                    {{ option.name + ' (' + option.province.name + ')' }}
                                </mat-option>
                            </mat-autocomplete>
                            <!-- error -->
                            <mat-error *ngIf="formGroup.get('localidad')?.errors?.match && !formGroup.get('localidad')?.errors?.required">
                                Localidad no encontrada. Seleccione alguna del desplegable.
                            </mat-error>
                            <mat-error *ngIf="formGroup.get('localidad')?.errors?.required">
                                Campo obligatorio.
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 mb-1">
                        <mat-form-field>
                            <mat-label>Provincia</mat-label>
                            <select matNativeControl formControlName="provincia" required>
                                <option *ngFor="let datos of provinces" value="{{datos.code}}">{{datos.code}}</option>
                            </select>
                            <!-- error -->
                            <mat-error>
                                Campo obligatorio.
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-lg-2 mt-1">
                        <div class="form-group">
                            <mat-form-field>
                                <mat-label>Teléfono de contacto</mat-label>
                                <input matInput type="text" oninvalid="" required formControlName="phone" maxlength="9">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="col-lg-4 mt-1">
                        <div class="form-group">
                            <mat-form-field>
                                <mat-label>Correo electrónico</mat-label>
                                <input matInput type="text" oninvalid="" required formControlName="email">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="col-lg-4 mt-1">
                        <div class="form-group">
                            <mat-form-field>
                                <mat-label>Confirmar correo electrónico</mat-label>
                                <input matInput type="text" oninvalid="" required formControlName="email_confirm">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </li>
        </ul>

    </div>

    <div *ngIf="showBankingData">
        <h5 class="title-step mt-4" align="center">
            <img src="./assets/img/users.svg" class="img-fluid ico-title" width="20"> Datos bancarios
        </h5>
        <div class="card">
            <ul class="list-group list-group-flush">
                <li class="list-group-item cuerpo-pack">
                    <div class="form-row mt-3">
                        <div class="col-lg-6">
                            <mat-form-field>
                                <mat-label>IBAN* (ESXX XXXX XXXX XX XXXXXXXXXX)</mat-label>
                                <input matInput type="text" required formControlName="bank_account"
                                       mask="AA00 0000 0000 00 0000000000" (input)="onIbanChange($event)">
                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 mb-0">
                            <div class="jumbotron-form2">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <span class="label-ad-text2">Titular de la cuenta</span>
                                        <br>
                                        <!-- Nombre titular operador -->
                                        <span class="label-ad-text">{{ fullNameBanking }}</span>
                                    </div>
                                    <small class="text-muted btn-muted">
                                        <button class="btn btn-green btn-sm" (click)="openModal()">Cambiar</button>
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <div *ngIf="true">
        <h5 class="title-step mt-4" align="center">
            <img src="./assets/img/package.svg" class="img-fluid ico-title" width="20">
            <span class="pe-4 ms-2">Tu plan pioneros</span>
            <a class="cursor-pointer" (click)="openModalPioneros(modalPioneros)">
                <img src="./assets/img/info.svg" class="img-fluid ico-title icon-white" width="20">
            </a>
        </h5>
        <div class="card">
            <ul class="list-group list-group-flush">
                <li class="list-group-item cuerpo-pack">
                    <div class="form-row">
                        <div class="col-lg-5 mb-0">
                            <mat-form-field>
                                <mat-label>¿Tienes padrino en República Móvil? Dinos quién es</mat-label>
                                <input type="text" matInput formControlName="sponsor">
                            </mat-form-field>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <!-- Continuar proceso -->
    <div align="center">
        <br>
        <button class="btn btn-black btn-block mb-1" (click)="next()">
            Continuar <img src="./assets/img/arrow-right-white.svg" class="img-fluid ico-title" width="15">
        </button>

        <button class="btn btn-grey2 btn-block mb-5" (click)="prev()">Volver</button>
        <br><br>
    </div>
</div>

<ng-template #modalPioneros let-modal>
    <div class="modal-header">
        <h5 class="modal-title white" id="exampleModalLabel">Plan pioneros</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">
                <img src="./assets/img/times2.svg" class="img-fluid ico-title" width="20">
            </span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row p-2">
            <div class="col-lg-12">
                <b>¿Qué es el Plan Pioneros?</b>
                <br>
                <span>Sabías que… ¡somos la compañía móvil que paga a sus clientes! Te damos 0.6€ por cada
                    amigo y por cada amigo de tus amigos en tarifas de contrato con cuota y 5% de sus recargas,
                    sin límites, solo por ser cliente.</span>
                <br>
                <br>
                <b>¿Cómo me doy de alta en el Plan Pioneros?</b>
                <br>
                <span>Para poder beneficiarte del <b>Plan Pioneros</b> otro cliente te tiene que referenciar cuando se haga
                    cliente de República Móvil. Es muy fácil. En el proceso de alta te pediremos que nos indiques el
                    número de teléfono de tu amigo (padrino).</span>
                <br>
                <br>
                <b>¿Qué es el padrino?</b>
                <br>
                <span>El padrino es la persona que te ha recomendado República Móvil. Para que nosotros sepamos
                    quién es y que podamos darle el beneficio del Plan Pioneros, tendrás que indicar su número de
                    teléfono cuando te des de alta. Cuando seas tú el que se lo recomiende a tus amigos, no
                    olvides decirles que indiquen tu número de teléfono ¡para empezar a ser padrino también!</span>
                <br>
                <br>
                <b>¿Cómo puedo invitar a mis amigos al Plan Pioneros?</b>
                <br>
                <span>Somos sociables y queremos compartir nuestro éxito así que, ¡invita a tus amigos para ganar
                    dinero todos los meses! Porque cuantos más somos, más ganamos. Solo tienes que
                    recordarles tu número de teléfono para que te pongan como “padrino” cuando se den de alta</span>
                <br>
                <br>
                <b>¿Cómo gano dinero con el Plan Pioneros en contrato?</b>
                <br>
                <span>Puedes ganar dinero todos los meses, si se lo recomiendas a tus amigos y te los traes como
                    clientes. Te daremos:</span>
                <br>
                <b>0.6€ por cada amigo en tarifas de contrato con cuota</b>
                <br>
                <b>5% de las recargas de tus amigos de prepago</b>
                <br>
                <span>Sin límite temporal y sin límite de número de amigos.</span>
                <br>
                <br>
                <b>¿Puedo cambiar de padrino?</b>
                <br>
                <span>Lo sentimos, pero una vez indicado el número de teléfono del padrino al darse de alta, no se
                    podrá modificar (ni cambiar ni anular).</span>
                <br>
                <br>
                <b>¿Y si se me olvida indicar quién es mi padrino?</b>
                <br>
                <span>¡No pasa nada! Si en el momento del alta no se indica número de teléfono de padrino, se
                    dispone de un mes después del alta para indicarlo.</span>
                <br>
                <br>
                <b>¿Qué es la tarjéta monedero?</b>
                <br>
                <span>Si tienes muchos amigos que suman un importe superior al de tu factura, te aplicamos
                    directamente el descuento que corresponda para dejarla a cero y la diferencia se irá
                    acumulando hasta que alcances un importe de 20€. En ese momento te enviamos una tarjeta
                    visa, con el importe acumulado.</span>
                <br>
                <span>Con nuestra tarjeta monedero podrás pagar en cualquier comercio. Esta tarjeta irá a tu nombre,
                    es personal e intransferible.</span>
                <br>
                <br>
                <b>¿Hay alguna condición para disfrutar del Plan Pioneros?</b>
                <br>
                <span>Todos los clientes de República Móvil disfrutarán del Plan Pioneros, siempre y cuando hagan
                    un uso adecuado del servicio. Te contamos los detalles a continuación para que no tengas
                    dudas:</span>
                <ul>
                    <li>Si un cliente no está ‘activo’ (fraude, impago, mal uso del servicio o baja) no se le aplicará
                        Plan Pioneros, ni para recibir descuentos o ingresos, ni a la hora de premiar a otros.
                    </li>
                    <li>Se aplicarán los descuentos o ingresos una vez transcurrido un mes natural en la
                        compañía. Se aplicará tanto al alta nueva, como a las altas de sus amigos.
                    </li>
                    <li>La línea del padrino tiene que ser más antigua (llevar más tiempo en República Móvil) que la
                        línea ahijada para que tenga efecto el beneficio.
                    </li>
                    <li>Para realizar los pagos al padrino, tiene que haber realizado el pago de una factura.</li>
                    <li>Todos los clientes deben estar al corriente de pago para poder realizarles el descuento o
                        ingreso que les corresponda.
                    </li>
                </ul>
            </div>
        </div>
    </div>
</ng-template>
